import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SupportFAQResponse, TransactionsResponse } from "reduxStore/dataTypes";

interface FAQState {
  supportFAQ: SupportFAQResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: FAQState = {
  supportFAQ: null,
  loading: false,
  error: null,
};

const supportFAQSlice = createSlice({
  name: "supportFAQ",
  initialState,
  reducers: {
    supportFAQRequest(state) {
      state.loading = true;
      state.error = null;
    },
    supportFAQSuccess(state, action: PayloadAction<SupportFAQResponse>) {
      state.loading = false;
      state.supportFAQ = action.payload;
    },
    supportFAQFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { supportFAQRequest, supportFAQSuccess, supportFAQFailure } =
  supportFAQSlice.actions;
export default supportFAQSlice.reducer;
